import { PaymentRequest, PaymentResponse } from "../../types/rtk/payment/payment";
import { apiSlice } from "../_api/api-slice";

const payEndpoint = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    postPayment: build.mutation<PaymentResponse, PaymentRequest>({
      query: (body) => ({
        url: `/payment/pay`,
        method: "post",
        body
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  usePostPaymentMutation,
} = payEndpoint;